/**
 * 레거시 네임스페이스 스텁 (Phase 2 기타 API용)
 */
export const EV123_API_NAMESPACE = '/api/ev123';

/** EVLINKNET_PORTAL_API — 상담 리드 등 공개 수집 (익명 POST 허용) */
export const EV123_EVC_NAMESPACE = '/api/ev123evc';

export function ev123Url(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${EV123_API_NAMESPACE}${p}`;
}

export function ev123EvcUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${EV123_EVC_NAMESPACE}${p}`;
}

/** EVOS 통계센터 (독립 도메인 — SPA 라우팅 대상 아님) */
export const STATS_CENTER_URL = 'https://stats.ev123.kr';
